import React from 'react';
import {EditableText} from '@blueprintjs/core';

import './VerboseName.scss';
import {useUpdateBlockVerboseName} from '../hooks';

interface VerboseNameProps {
  uid: string;
  disabled: boolean;
}

export const VerboseName = ({
  uid,
  disabled,
}: VerboseNameProps) => {
  /*
   * Verbose name is different from block name.
   * Block name is used in execution, Verbose name is used on the Frontend.
   */
  const {value, updateBlockVerboseName} = useUpdateBlockVerboseName(uid);

  const onConfirm = (value: string) => {
    updateBlockVerboseName(value);
  }

  return (
    <div className="verbose-name">
      <EditableText
        defaultValue={value}
        className="verbose-name__input"
        onConfirm={onConfirm}
        disabled={disabled}
      />
    </div>
  );
};

export default VerboseName;
